import React, { Component } from "react";
import "./products.css";
import { getproductsByCategoryId } from "../../constants/products-constant";
import ProductItemCard from "./ProductItemCard";

class ProductItemGroup extends Component {
    
    state = {
        products: []
    };

    componentDidMount() {
        this.setState({ products: getproductsByCategoryId(this.props.categoryValue) });
    }

    componentWillReceiveProps(categoryValue) {
        this.setState({ products: getproductsByCategoryId(categoryValue.categoryValue) });
    }

    render() {
        return (
            <React.Fragment key={this.props.categoryKey}>
                <section className="container" key={this.props.categoryLabel + "container"}>
                    <div className="row hrow product_cat" key={this.props.categoryLabel + "row"}>
                        <h3 className="title" key={this.props.categoryLabel + "title"}>{this.props.categoryLabel}</h3>
                        <p key={this.props.categoryLabel + "p"} style={{ textAlign:"justify"}}>
                            {this.props.categoryDescription}
                        </p>
                        {this.state.products.map(productItem => (
                            <ProductItemCard key={productItem.id} id={productItem.id} name={productItem.title} imageAddress={productItem.imageSquareAddress} />
                        ))}
                    </div>
                </section>
            </React.Fragment >
        );
    }
}

export default ProductItemGroup;